import { Phone, Mail, Globe, Facebook, Twitter, Linkedin, ArrowRight } from 'react-feather';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#0e0e0e] text-gray-400 pt-16 pb-10 mt-24 z-10 relative border-t border-gray-700">
      <div className="container mx-auto px-6 lg:px-12">
        {/* CTA Section */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white">
            Power Your Energy Finance with LonaPay
          </h2>
          <p className="mt-4 text-gray-400 max-w-2xl mx-auto">
            Join our ecosystem of riders, providers, contractors, and investors. Simplify payments,
            access credit, and grow with Africa’s fuel future.
          </p>
          <Link
            to="/get-started"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-[#F7931E] text-black font-bold rounded-lg shadow-lg hover:bg-[#FFA94D] transition"
          >
            Get Started <ArrowRight size={16} />
          </Link>
        </div>

        {/* Main Footer Links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b border-gray-700">
          {/* Brand & Contact */}
          <div className="space-y-4">
            <h3 className="text-white font-bold text-lg">LonaPay</h3>
            <p className="text-sm text-gray-400 max-w-xs">
              Fueling Africa’s oil & gas logistics sector with smart finance, real-time payments,
              and scalable digital tools.
            </p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Phone size={14} /> +256 782 692271
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} /> lonapay.ops@gmail.com
              </li>
              <li className="flex items-center gap-2">
                <Globe size={14} /> lonapay.org
              </li>
            </ul>
            <div className="flex items-center gap-4 mt-4">
              {[Linkedin, Twitter, Facebook].map((Icon, idx) => (
                <a
                  key={idx}
                  href="#"
                  className="hover:text-[#F7931E] transition-transform transform hover:scale-110"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold mb-4">Products</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products/mobile-app" className="hover:text-[#F7931E]">
                  LonaPay Mobile App
                </Link>
              </li>
              <li>
                <Link to="/products/gas-token" className="hover:text-[#F7931E]">
                  Gas Token Wallet
                </Link>
              </li>
              <li>
                <Link to="/products/advancepay" className="hover:text-[#F7931E]">
                  AdvancePay Contractors
                </Link>
              </li>
              <li>
                <Link to="/products/ussd" className="hover:text-[#F7931E]">
                  USSD Interface
                </Link>
              </li>
              <li>
                <Link to="/products/apis" className="hover:text-[#F7931E]">
                  Gateway APIs
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/company/about" className="hover:text-[#F7931E]">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/company/team" className="hover:text-[#F7931E]">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/company/vision" className="hover:text-[#F7931E]">
                  Vision & Mission
                </Link>
              </li>
              <li>
                <Link to="/partnerships" className="hover:text-[#F7931E]">
                  Partnerships
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-[#F7931E]">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/resources/blog" className="hover:text-[#F7931E]">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/resources/whitepapers" className="hover:text-[#F7931E]">
                  Whitepapers
                </Link>
              </li>
              <li>
                <Link to="/resources/insights" className="hover:text-[#F7931E]">
                  Industry Insights
                </Link>
              </li>
              <li>
                <Link to="/resources/banks-vs-lonapay" className="hover:text-[#F7931E]">
                  Banks vs LonaPay
                </Link>
              </li>
              <li>
                <Link to="/resources/mobile-vs-lonapay" className="hover:text-[#F7931E]">
                  Mobile Money vs LonaPay
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legal/terms" className="hover:text-[#F7931E]">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="hover:text-[#F7931E]">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/cookies" className="hover:text-[#F7931E]">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 pt-6 mt-6">
          <p>&copy; {new Date().getFullYear()} LonaPay. All Rights Reserved.</p>
          <div className="mt-2 md:mt-0 flex gap-4">
            <Link to="/legal/terms" className="hover:text-[#F7931E]">
              Terms
            </Link>
            <Link to="/legal/privacy" className="hover:text-[#F7931E]">
              Privacy
            </Link>
            <Link to="/legal/cookies" className="hover:text-[#F7931E]">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
